const emptyMetric = {
  total: undefined,
  value: undefined,
  changeFormatted: '',
  change: 0,
};

const defaultState = {
  loading: true,
  error: undefined,
  fulfillmentType: undefined, // 'restaurant' || 'deliveroo',
  metrics: {
    grossOrders: { ...emptyMetric },
    totalOrders: { ...emptyMetric },
    totalDeliveredOrders: { ...emptyMetric },
    prepTime: { ...emptyMetric },
    waitTimePastTargetSum: { ...emptyMetric },
  },
};

const SUPPORTED_METRICS = [
  'grossRevenue',
  'orderRating',
  'orderRatingBenchmark',
  'prepTime',
  'prepTimeBenchmark',
  'totalOrders',
  'totalDeliveredOrders',
  'totalRejectedOrders',
  'waitTimePastTargetSum',
];

const metricsReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case 'FETCH_METRICS_REQUEST': {
      return {
        ...state,
        loading: true,
        error: undefined,
        metrics: { ...defaultState.metrics },
      };
    }

    case 'FETCH_METRICS_SUCCESS': {
      const response = action.payload;
      const metrics = response.metrics.reduce((result, metric) => {
        // to camel-case for eslint
        const key = metric.name.replace(/_([a-z])/g, (g) => g[1].toUpperCase());

        // Don't consume metrics we don't use (Note: We consume rejectReasons below)
        if (!SUPPORTED_METRICS.includes(key)) return result;

        // eslint-disable-next-line no-param-reassign
        result[key] = {
          changeFormatted: metric.change.formatted,
          change: parseFloat(metric.change.fractional, 10),
          name: String(metric.name),
          totalFormatted: String(metric.total.formatted),
          total: parseFloat(metric.total.fractional, 10),
          timeSeries: (metric.time_series || []).map((timeSeries) => ({
            time: parseFloat(timeSeries.time * 1000, 10),
            value: timeSeries.value,
            x: parseFloat(timeSeries.time * 1000, 10),
            y: parseFloat(timeSeries.value, 10),
          })),
        };

        return result;
      }, {});

      const totalOrders = metrics.totalOrders.total;

      metrics.rejectedOrders = {
        total: metrics.totalRejectedOrders.total,
        totalFormatted: metrics.totalRejectedOrders.totalFormatted,
        ofAllOrders: metrics.totalRejectedOrders.total / totalOrders || 0,
        reasons: response.metrics
          .filter(({ name }) => /^reject_reason/.test(name))
          .filter(({ total }) => parseFloat(total.fractional, 10) > 0)
          .map(({ name, total }) => ({
            key: name.replace('reject_reason_', ''),
            total: parseFloat(total.fractional, 10),
            ofAllOrders: total.fractional / totalOrders || 0,
          })),
      };

      return {
        loading: false,
        error: undefined,
        fulfillmentType: response.fulfillment_type,
        metrics,
      };
    }

    case 'FETCH_METRICS_FAILURE': {
      const { status } = action;

      return {
        ...state,
        error: {
          status,
        },
        loading: false,
      };
    }
    default:
      return state;
  }
};

export default metricsReducer;
